/**
 * Vizit Help Center home, opened from the Help Center item in the account menu (GRE-454).
 */
export const HELP_CENTER_URL = 'https://vizit.support.site/';

/**
 * Help Center article backing the "Learn more" action on the collection-scoring accuracy
 * advisory (SPM-3175).
 *
 * `null` until the article exists — callers must skip the link rather than render a dead one.
 */
export const COLLECTION_SCORING_ACCURACY_HELP_URL: string | null = null;

/**
 * Help Center article backing the "How Spark works" link in the Spark Images tab footer (GRE-386).
 *
 * `null` until the article exists — callers must skip the link rather than render a dead one.
 */
export const HOW_SPARK_WORKS_HELP_URL: string | null = null;
